import { render, staticRenderFns } from "./1182_与目标颜色间的最短距离.md?vue&type=template&id=b8991032&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports